var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-form',{attrs:{"value":_vm.value,"title":_vm.$localize('DeleteDashboard.title'),"action":"delete"},on:{"input":function($event){return _vm.$emit('input', $event)},"commit":_vm.save}},[_c('p',[_vm._v(_vm._s(_vm.$localize('DeleteDashboard.description')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }